import * as React from 'react';

function ExternalLinkIcon(props) {
	return (
		<svg
			aria-label={`external link icon`}
			xmlns={'http://www.w3.org/2000/svg'}
			width={'18'}
			height={'18'}
			viewBox={'0 0 18 18'}
			fill={'none'}
			{...props}
		>
			<path d={'M17 11.3992V16.8992H1V0.89917H6'} stroke={'black'} strokeWidth={'1.5'} />
			<path d={'M17 7.89917L17 0.89917L10 0.89917'} stroke={'black'} strokeWidth={'1.5'} />
			<path d={'M17 1.39917L7 11.3992'} stroke={'black'} strokeWidth={'1.5'} />
		</svg>
	);
}

export default ExternalLinkIcon;
